import BoxLoader from "../commons/BoxLoader/BoxLoader";
import { CircularAvatar } from "../commons";
import { showDateWithMonthAndYear } from "../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { UpcomingBirthdayListType } from "../../redux/mySpace/mySpaceTypes";
import moment from "moment";
type AppProps = {
  data: UpcomingBirthdayListType[] | [];
  fetching: boolean;
};

const UpcomingBirthdays = ({ data, fetching }: AppProps) => {
  let todayDate = moment(new Date()).format("DD-MM-YYYY");

  return (
    <div className="boxs m-0 w-100">
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div
            className="pl-3 pt-3 pr-3 pb-3 "
            style={{ fontSize: "18px", fontWeight: 600 }}
          >
            Upcoming Birthdays
          </div>
          {data?.length
            ? data?.map((el: any) => {
                const eventDate = el?.upcoming_event_date;
                const formattedDate = showDateWithMonthAndYear(
                  el?.upcoming_event_date
                );

                return (
                  <div
                    className="pl-3 p-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #bfcbe1",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        gap: "14px",
                      }}
                    >
                      <CircularAvatar
                        name={`${el?.user_name} `}
                        image={el?.profile_pic && el?.profile_pic?.file_url}
                      />
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "14px" }}>
                          {el?.user_name}
                        </span>
                        <span style={{ color: "#6e7491", fontSize: "12px" }}>
                          {el?.job_title?.length + el?.department?.length >
                          20 ? (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view">
                                  {`${el?.job_title} ${el?.department}`}
                                </Tooltip>
                              }
                            >
                              <span>
                                {(
                                  el?.job_title +
                                  ", " +
                                  el?.department
                                )?.substr(0, 20) +
                                  (el?.job_title &&
                                  el?.job_title?.length + el?.department > 20
                                    ? "..."
                                    : "")}
                              </span>
                            </OverlayTrigger>
                          ) : (
                            `${el?.job_title ? el?.job_title : ""} ${
                              el?.department ? el?.department : ""
                            }`
                          )}
                        </span>
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-center mr-2"
                      style={{
                        fontSize: "14px",
                        color: todayDate === eventDate ? "#2080f6" : "inherit",
                      }}
                    >
                      {todayDate === eventDate ? "TODAY" : formattedDate}
                    </div>
                  </div>
                );
              })
            : ""}
        </>
      )}
    </div>
  );
};

export default UpcomingBirthdays;
